"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _HowToPlaySteps = _interopRequireDefault(require("./HowToPlaySteps"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledDropdownWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  margin: 0 auto;\n  width: 90%;\n  max-height: ", ";\n  border-radius: ", ";\n  background: ", ";\n  transition: max-height 0.5s;\n"])), function (props) {
  return props.dropdownOpen ? "1000px" : "3rem";
}, function (p) {
  return p.theme.borderRadius;
}, function (props) {
  return props.theme.colorPrimary;
});

var StyledDropdownHeader = _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 700;\n  font-family: ", ";\n  text-transform: uppercase;\n  height: 3rem;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding-left: 1rem;\n  justify-content: center;\n  color: ", ";\n"])), function (p) {
  return p.theme.fontFamilySpecial;
}, function (props) {
  return props.theme.colorPrimaryText;
});

var StyledDropdownContent = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: grid;\n  gap: 1rem;\n  min-height: 100px;\n  padding: 1rem;\n  font-size: 0.75rem;\n  font-weight: 400;\n  background: ", ";\n"])), function (p) {
  return p.theme.colorLightGrey;
});

var StyledDropdownIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-right: 0.5rem;\n  transform: rotate(", ");\n  transition: transform 0.35s;\n"])), function (props) {
  return props.dropdownOpen ? "180deg" : "0deg";
});
var StyledRulesButton = (0, _styledComponents.default)(_fiverReactUiComponents.BlockButton)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border-radius: 50px;\n"])));

var HowToPlay = function HowToPlay(_ref) {
  var activePickem = _ref.activePickem,
      prizepool = _ref.prizepool,
      split = _ref.split,
      onRulesClicked = _ref.onRulesClicked;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdownOpen = _useState2[1];

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.contest;
  }),
      translations = _useSelector.translations;

  return split ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledDropdownWrapper, {
    dropdownOpen: dropdownOpen,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDropdownHeader, {
      onClick: function onClick() {
        return setDropdownOpen(!dropdownOpen);
      },
      children: split && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [translations.howToPlay, /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDropdownIcon, {
          dropdownOpen: dropdownOpen,
          children: "expand_more"
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledDropdownContent, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_HowToPlaySteps.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRulesButton, {
        onClick: onRulesClicked,
        children: translations.rules
      })]
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
    display: "block",
    margin: "0 15%",
    skeletonWidth: "70%",
    skeletonHeight: "40px"
  });
};

var _default = HowToPlay;
exports.default = _default;